import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import 'devextreme/dist/css/dx.light.css';
import './polyfill'
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
 
import { icons } from './assets/icons'

import { Provider } from 'react-redux'
import { store } from './store'

import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { defaultLocale, dynamicActivate } from './i18n.js';

import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';



React.icons = icons

const BaseAppLoader = () => {
  useEffect(() => {
    if(store.getState().currentUser.language !== null && store.getState().currentUser.language !== "") {
      //console.log('BaseAppLoader - dynamicActivate - store.getState().currentUser.language', store.getState().currentUser.language);
      dynamicActivate(store.getState().currentUser.language)
    }
    else {
      //console.log('BaseAppLoader - dynamicActivate - defaultLocale', defaultLocale);
      dynamicActivate(defaultLocale)
    }    
  }, [])

  return (
    <Provider store={store}>      
        <I18nProvider i18n={i18n}>          
          <App/>
          <ToastContainer
            className="impct-toast"
            position="bottom-right"
            autoClose={3000}
            hideProgressBar="false"
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable={false}
            pauseOnHover
            transition={Slide}
            limit={10}
          />
        </I18nProvider>     
    </Provider>     
  )
};

ReactDOM.render(<BaseAppLoader />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
